import React, { useCallback, useMemo } from "react";
import PageBox from "../../../components/PageBox/PageBox.component";
import styles from "./Style.module.css";
import DataTables from "../../../Datatables/Datatable.table";
import Constants from "../../../config/constants";
import CustomSelectField from "../../../components/FormFields/SelectField/SelectField.component";
import { ButtonBase, CircularProgress, MenuItem } from "@material-ui/core";
import useSalaryReportListHook from "./SalaryReportList.hook";
import classNames from "classnames";
import StatusPill from "../../../components/Status/StatusPill.component";
import { Add } from "@material-ui/icons";
import { useSelector } from "react-redux";
import CustomDatePicker from "../../../components/FormFields/DatePicker/CustomDatePicker";
import payRollImg from "../../../assets/img/ic_run_payroll2x.png";
import CustomMonthYearPicker from "../../../components/FormFields/DatePicker/CustomMonthYearPicker";
import { subYears } from 'date-fns';

const SalaryReportlist = () => {
  const {
    form,
    totalShow,
    handleSubmit,
    currentData,
    currentPage,
    handlePageChange,
    data,
    handleRowSize,
    generatePaySlip,
    handleSortOrderChange,
    changeTextData,
    isCalling,
    handlePayslipGenerate,
    lastPayslipGenrated,
    isGenerated,
    handleDownload,
    isDownload
  } = useSalaryReportListHook();

  const renderStatus = useCallback((status) => {
    return <StatusPill status={status} />;
  }, []);

  const renderFirstCell = useCallback((obj) => {
    if (obj) {
      return (
        <div className={styles.firstCellFlex}>
          <div className={classNames(styles.firstCellInfo, "openSans")}>
            <div>
              <span className={styles.employeeName}>{obj?.employee_name}</span>
              <br />
              <span>{obj?.employee_code}</span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }, []);

  const renderSecondCell = useCallback((obj) => {
    if (obj) {
      return (
        <div className={styles.firstCellFlex}>
          <div className={classNames(styles.firstCellInfo, "openSans")}>
            <div>
              <div>{obj?.employee_department}</div>
              <div>{obj?.employee_role}</div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }, []);

  const renderThirdCell = useCallback((obj) => {
    if (obj) {
      return (
        <div className={styles.firstCellFlex}>
          <div className={classNames(styles.firstCellInfo, "openSans")}>
            <div>
              <span>{obj?.employee_location}</span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }, []);

  const tableStructure = useMemo(() => {
    return [
      {
        key: "employee",
        label: "EMPLOYEE",
        sortable: false,
        fixed: true,
        render: (value, all) => <div>{renderFirstCell(all)}</div>,
      },

      {
        key: "department",
        label: "DEPARTMENT/ROLE",
        sortable: false,
        render: (temp, all) => <div>{renderSecondCell(all)}</div>,
      },
      {
        key: "location",
        label: "LOCATION",
        sortable: false,
        render: (temp, all) => <div>{renderThirdCell(all)}</div>,
      },
      {
        key: "employee_status",
        label: "EMPLOYEE STATUS",
        sortable: false,
        render: (temp, all) => renderStatus(all?.employee_status),
      },
      {
        key: "employee_gross_salary",
        label: "GROSS SALARY",
        sortable: false,
        render: (temp, all) => <div>{all?.employee_gross_salary}</div>,
      },
      {
        key: "working_days",
        label: "TOTAL WORKING DAYS",
        sortable: false,
        render: (temp, all) => <div>{all?.working_days}</div>,
      },
      {
        key: "employee_basic_salary",
        label: "BASIC SALARY",
        sortable: false,
        render: (temp, all) => <div>{all?.employee_basic_salary}</div>,
      },
      {
        key: "employee_hra",
        label: "HRA",
        sortable: false,
        render: (temp, all) => <div>{all?.employee_hra}</div>,
      },
      {
        key: "unpaid_leave",
        label: "UNPAID LEAVE",
        sortable: false,
        render: (temp, all) => <div>{all?.unpaid_leave}</div>,
      },
      {
        key: "other_deductions",
        label: "OTHER DEDUCTIONS",
        sortable: false,
        render: (temp, all) => <div>{all?.other_deductions}</div>,
      },
      {
        key: "penalty",
        label: "PENALTY",
        sortable: false,
        render: (temp, all) => <div>{all?.penalty}</div>,
      },
      {
        key: "advance_deductions",
        label: "ADVANCE DEDUCTIONS",
        sortable: false,
        render: (temp, all) => <div>{all?.advance_deductions}</div>,
      },
      {
        key: "annual_bonus",
        label: "ANNUAL BONUS",
        sortable: false,
        render: (temp, all) => <div>{all?.annual_bonus}</div>,
      },
      {
        key: "total_earnings",
        label: "TOTAL EARNINGS(A)",
        sortable: false,
        render: (temp, all) => <div>{all?.total_earnings}</div>,
      },
      {
        key: "employees_esic",
        label: "EMPLOYEE'S ESIC",
        sortable: false,
        render: (temp, all) => <div>{all?.employees_esic}</div>,
      },
      {
        key: "employees_epf",
        label: "EMPLOYEE'S EPF",
        sortable: false,
        render: (temp, all) => <div>{all?.employees_epf}</div>,
      },
      {
        key: "employees_contributions",
        label: "EMPLOYEE's CONTRIBUTIONS(B)",
        sortable: false,
        render: (temp, all) => <div>{all?.employees_contributions}</div>,
      },
      {
        key: "employers_esic",
        label: "EMPLOYER's ESIC",
        sortable: false,
        render: (temp, all) => <div>{all?.employers_esic}</div>,
      },
      {
        key: "employers_epf",
        label: "EMPLOYER'S EPF",
        sortable: false,
        render: (temp, all) => <div>{all?.employers_epf}</div>,
      },
      {
        key: "edli",
        label: "EDLI",
        sortable: false,
        render: (temp, all) => <div>{all?.edli}</div>,
      },
      {
        key: "administrative_charges",
        label: "ADMINISTRATIVE CHARGES",
        sortable: false,
        render: (temp, all) => <div>{all?.administrative_charges}</div>,
      },
      {
        key: "food_expenses",
        label: "FOOD EXPENSES",
        sortable: false,
        render: (temp, all) => <div>{all?.food_expenses}</div>,
      },

      {
        key: "employers_contributions",
        label: "EMPLOYER'S CONTRIBUTIONS (C)",
        sortable: false,
        render: (temp, all) => <div>{all?.employers_contributions}</div>,
      },
      {
        key: "ctc",
        label: "CTC (A+B+C)",
        sortable: false,
        render: (temp, all) => <div>{all?.ctc}</div>,
      },
      {
        key: "overtime",
        label: "overtime",
        sortable: false,
        render: (temp, all) => <div>{all?.overtime}</div>,
      },
      {
        key: "employee_net_salary",
        label: "NET PAYABLE",
        sortable: false,
        render: (temp, all) => <div>{all?.employee_net_salary}</div>,
      },
    ];
  }, [renderStatus, renderFirstCell, isCalling]);

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: currentData,
      count: data.length,
      page: currentPage - 1,
      rowsPerPage: 10,
      allRowSelected: false,
      showSelection: false,
    };

    return { datatableFunctions, datatable };
  }, [
    data,
    handlePageChange,
    handleSortOrderChange,
    handleRowSize,
    tableStructure,
    currentData,
    currentPage,
  ]);

  return (
    <>
      <div className={styles.topContainer}>
        <PageBox>
          <div className={styles.headerContainer}>
            <div>
              <span className={styles.title}>Salary Report</span>
              <div className={styles.newLine} />
            </div>
            <ButtonBase
              disabled={!isDownload}
              onClick={handleDownload}
              className={"createBtnOutland"}
            >
             DOWNLOAD
            </ButtonBase>
          </div>

          <div className={styles.formFlex}>
            <div className={styles.formGroup}>
              <CustomMonthYearPicker
                 views={["year"]}  
                 disabled={isCalling}
                 clearable
                 value={form?.year && new Date(Number(form?.year), new Date().getMonth(), new Date().getDate()) 
                }
                 onChange={(value) => {
                  changeTextData(value, "year");
                 }}
                 label="Year"
                 minDate={subYears(new Date(),30)}
              />
            </div>

            <div className={styles.formGroup}>
               <CustomMonthYearPicker
                 views={["month"]}  
                 value={form?.month &&  new Date(Number(form?.year), Number(form?.month), 1) }
                 clearable
                 disabled={isCalling}
                 onChange={(value) => {
                  changeTextData(value, "month");
                 }}
                 label="Month"
                //  maxDate={form?.year ? new Date(Number(form?.year), 11, 31) : new Date()} 
                maxDate={form?.year && Number(form?.year) === new Date().getFullYear() ? new Date() : new Date(Number(form?.year), 11, 31)}
                 minDate={form?.year ? new Date(Number(form?.year), 0, 1) : new Date()}
                //  maxDate={
                //   form?.year
                //     ? new Date(Number(form?.year), new Date().getMonth(), new Date().getDate()) 
                //     : new Date()  
                // }
              />
            </div>
            <ButtonBase onClick={handlePayslipGenerate} disabled={isGenerated || isCalling} className={isGenerated || isCalling ? "createBtnResetDisable" : "createBtn"}>
              RUN PAYROLL
              <img src={payRollImg} className={styles.payrollimg} />
            </ButtonBase>
            <div className={styles.progressBar}>
              {isCalling && <CircularProgress color="success" size="20px" />}
            </div>
            <div className={styles.formGroup}></div>
          </div>

          <div className={styles.formFlex}>
            <div className={styles.Heading}>LAST PAYSLIP GENERATED</div>
            <div className={styles.Heading}>DATE GENERATED</div>
          </div>
          <div className="formFlex">
            <div className={styles.headingValue}>
              {lastPayslipGenrated?.lastPaySlipGenerated}
            </div>
            <div className={styles.headingValue}>
              {lastPayslipGenrated?.dateGenerated}
            </div>
          </div>
        </PageBox>
      </div>
      {currentData?.length > 0 && (
        <div>
          <PageBox>
            <div>
              <DataTables
                {...tableData.datatable}
                {...tableData.datatableFunctions}
              />
            </div>
          </PageBox>
        </div>
      )}
    </>
  );
};

export default SalaryReportlist;
